<template>
  <div>
    <VehiclesProviderPriceNav></VehiclesProviderPriceNav>
    <div>
      <div class="container-fluid">
        <b-row>
          <b-col>
            <h4 class="ml-3 mt-2">Vehicles price</h4>
          </b-col>
        </b-row>
        <b-row class="mb-1 mr-1 ml-1">
          <b-col xs="12" sm="12" md="12" lg="3" xl="3" class="mt-1">
            <b-form-group label="Vin:">
              <b-form-input
                id="filterInput"
                v-model="filter"
                class="filter-input rounded-right rounded-left"
                type="search"
                placeholder="Search by VIN"
              />
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="12" md="12" lg="3" xl="3" class="mt-1">
            <b-form-group label="From:">
              <b-form-datepicker
                v-model="dateFrom"
                reset-button
              ></b-form-datepicker>
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="12" md="12" lg="3" xl="3" class="mt-1">
            <b-form-group label="To:">
              <b-form-datepicker
                v-model="dateTo"
                reset-button
              ></b-form-datepicker>
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="12" md="12" lg="3" xl="3" class="mt-1">
            <b-button variant="success" class="mt-4 mr-1" @click="getData()">
              <b-icon icon="search"></b-icon> Search
            </b-button>
          </b-col>
        </b-row>
        <div class="pt-4">
          <b-row class="mx-0">
            <b-col xs="12" sm="12" md="12" lg="6" xl="6">
              <h5 class="">Vehicle</h5>

              <div class="">
                <b-table
                  thead-class="text-center bg-light-grey "
                  head-variant="light"
                  bordered
                  small
                  show-empty
                  outlined
                  stacked="md"
                  :fields="fields"
                  :items="vehicles.data"
                  id="tableMain"
                  :busy="isLoadingVehicles"
                  class="text-break compact-table table"
                >
                  <template #empty>
                    <div class="text-center">
                      <h6>{{ $t("thereAreNoRecordsToShow") }}</h6>
                    </div>
                  </template>
                  <template #table-busy>
                    <div class="text-center text-primary my-2">
                      <b-spinner
                        variant="primary"
                        class="align-middle"
                      ></b-spinner>
                      <p>Loading</p>
                    </div>
                  </template>
                  <template v-slot:cell(website)="{ item }">
                    <a :href="item.website" target="_blank">
                      {{ item.website }}
                    </a>
                  </template>
                  <template v-slot:cell(info)="{ item }">
                    <label v-if="item.manual == 1"> Manual</label>
                    <label v-else-if="item.manual == 0"> API</label>
                  </template>

                  <template v-slot:cell(type)="{ item }">
                    <label v-if="item.wholesale == 1"> Wholesale</label>
                    <label v-if="item.wholesale == 0"> Retail</label>
                  </template>

                  <template v-slot:cell(actions)="row">
                    <div class="text-center">
                      <b-form-group>
                        <b-icon
                          v-b-tooltip.hover
                          title="Details"
                          icon="eye"
                          class="h5 m-2 cursor-pointer"
                          @click="
                            () => {
                              row.toggleDetails();
                              getVehiclePrices(row.item);
                            }
                          "
                        ></b-icon>
                      </b-form-group>
                    </div>
                  </template>
                </b-table>

                <!-- Enhanced Vehicle MMR component in a card -->
                <div v-if="vehicles.data.length > 0" class="mt-3">
                  <b-overlay
                    :show="isLoadingVehicles"
                    rounded="sm"
                    spinner-variant="primary"
                  >
                    <template v-if="selectedVehicle">
                      <b-card no-body>
                        <b-card-header
                          class="d-flex justify-content-between align-items-center p-2"
                        >
                          <h6 class="mb-0">Details</h6>
                        </b-card-header>
                        <VehicleMMR
                          :vehicle="selectedVehicle"
                          :showTitle="false"
                        />
                      </b-card>
                    </template>
                    <template v-else>
                      <b-alert show variant="info" class="mb-0">
                        <b-icon icon="info-circle-fill" class="mr-2"></b-icon>
                        Click on a vehicle in the table to view detailed
                        information
                      </b-alert>
                    </template>
                  </b-overlay>
                </div>
              </div>
            </b-col>
            <b-col xs="12" sm="12" md="12" lg="6" xl="6">
              <VehiclesCoincidencesTable
                @download-excel="handleDownloadExcel"
              />
            </b-col>
          </b-row>

          <ProvidersPriceTable
            v-if="
              vehicles.data != null &&
              vehicles.data != [] &&
              vehicles.data.length > 0
            "
            :vehicleId="vehicles.data[0].id"
            :dateFrom="dateFrom"
            :dateTo="dateTo"
            @download-providers-excel="downloadXL"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { generalMixin } from "@/modules/mixin.js";
import {
  GET_PRICE_XLS,
  GET_VEHICLES_LIST_PROVIDER_PRICE,
  GET_VEHICLES_PROVIDER_PRICE_BY_ID,
  GET_COINCIDENCES_XLS,
  GET_COINCIDENCES,
} from "./actions";
import ProvidersPriceTable from "./ProvidersPriceTable.vue";
import VehiclesProviderPriceNav from "./VehiclesProviderPriceNav.vue";
import VehiclesCoincidencesTable from "./VehiclesCoincidencesTable.vue";
import VehicleMMR from "./VehicleMMR.vue";
export default {
  name: "ProviderTable",
  components: {
    ProvidersPriceTable,
    VehiclesProviderPriceNav,
    VehiclesCoincidencesTable,
    VehicleMMR,
  },
  mixins: [generalMixin],
  computed: {
    ...mapState({
      vehicles: (state) => state.adminStore.vehiclesProviderPrice.vehicles,
      isLoadingVehicles: (state) =>
        state.adminStore.vehiclesProviderPrice.vehicles.status == "fetching",
    }),
    selectedVehicle() {
      if (!this.selectedVehicleId || !this.vehicles.data.length) {
        return this.vehicles.data.length ? this.vehicles.data[0] : null;
      }
      return (
        this.vehicles.data.find(
          (vehicle) => vehicle.id === this.selectedVehicleId
        ) || this.vehicles.data[0]
      );
    },
  },
  data() {
    return {
      fields: [
        { key: "vinNumber", label: "Vin", class: "text-center" },
        { key: "year", label: "Year", class: "text-center" },
        { key: "make", label: "Make", class: "text-center" },
        { key: "model", label: "Model", class: "text-center" },
        { key: "trim", label: "Trim", class: "text-center" },
        {
          key: "mileage",
          label: "Mileage",
          class: "text-center",
          formatter: (value) => this.$options.filters.formatNumber(value),
        },
      ],

      providerItem: {},
      filter: "",
      dateFrom: null,
      dateTo: null,
      selectedVehicleId: null,
    };
  },
  methods: {
    getData() {
      const payload = {
        search: this.filter,
        status: 1,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
      };
      this.$store
        .dispatch(GET_VEHICLES_LIST_PROVIDER_PRICE, payload)
        .then(() => {})
        .catch(() => {
          this.$root.$bvToast.toast("error", {
            title: "Error",
            variant: "warning",
          });
        });
    },
    handleDownloadExcel(type) {
      const payload = {
        search: this.filter,
        dateFrom: this.dateFrom ? this.dateFrom : null,
        dateTo: this.dateTo ? this.dateTo : null,
        type: type,
      };
      this.$store.dispatch(GET_COINCIDENCES_XLS, payload).then((response) => {
        const blob = new Blob([response], {
          type: "application/vnd.ms-excel",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download =
          this.formatFileName(`${type}-coincidences`) || "ficher.xls";
        link.click();
      });
    },

    showModal() {
      this.$bvModal.show("providerModal");
    },
    editItem(item) {
      console.log(item);
      this.providerItem = item;
      this.$bvModal.show("providerModal");
    },
    changePage(page, filter = "") {
      const payload = {
        search: filter,
        page: page,
      };
      this.$store
        .dispatch(GET_VEHICLES_LIST_PROVIDER_PRICE, payload)
        .then(() => {})
        .catch(() => {
          this.$root.$bvToast.toast("error", {
            title: "Error",
            variant: "warning",
          });
        });
    },

    getVehiclePrices(item) {
      console.log("Selected vehicle item:", item);
      this.providerItem = item;
      this.selectedVehicleId = item.id;

      // Show a loading toast
      this.$bvToast.toast("Loading vehicle details...", {
        title: "Loading",
        variant: "info",
        autoHideDelay: 1000,
      });

      // Fetch vehicle prices
      this.$store
        .dispatch(GET_VEHICLES_PROVIDER_PRICE_BY_ID, {
          id: item.id,
        })
        .then((response) => {
          console.log("Vehicle price details:", response);
        })
        .catch((error) => {
          console.error("Error fetching vehicle prices:", error);
          this.$bvToast.toast("Failed to load vehicle price details", {
            title: "Error",
            variant: "danger",
          });
        });

      // Fetch coincidences for the selected vehicle
      this.$store
        .dispatch(GET_COINCIDENCES, {
          vehicleId: item.id,
        })
        .catch((error) => {
          console.error("Error fetching coincidences:", error);
        });
    },
    downloadXL() {
      try {
        if (!this.vehicles.data[0].id) {
          throw new Error("No vehicle selected for download.");
        }
        const payload = {
          id: this.vehicles.data[0].id,
          dateFrom: this.dateFrom ? this.dateFrom : null,
          dateTo: this.dateTo ? this.dateTo : null,
          type: "vehicles",
        };
        this.$store.dispatch(GET_PRICE_XLS, payload).then((response) => {
          const blob = new Blob([response], {
            type: "application/vnd.ms-excel",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download =
            this.formatFileName("vehicles") + ".xls" || "ficher.xls";
          link.click();
        });
      } catch (error) {
        console.error("Error downloading Excel:", error);
        this.$bvToast.toast(error.message, {
          title: "Error",
          variant: "danger",
        });
        return;
      }
    },
    formatFileName(type) {
      const date = new Date();
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      return `${type}-${year}-${month}-${day}`;
    },

    hideModal() {
      this.$bvModal.hide("providerModal");
    },
  },
  mounted() {
    /* get vinNumber param from route */
    const vinNumber = this.$route.params.vinNumber;
    if (vinNumber) {
      this.filter = vinNumber;
      this.getData();
    }
  },
};
</script>
<style scoped>
/* Smaller font size for tables */
.table th,
.table td {
  font-size: 0.75rem; /* 75% of the default font size */
  padding: 0.35rem !important;
  line-height: 1.2;
}

/* Compact table specific styles */
.compact-table {
  margin-bottom: 0.5rem;
}

.compact-table th {
  font-weight: 600;
  white-space: nowrap;
}

/* Reduce h5 and h6 sizes */
h5 {
  font-size: 1rem;
}

h6 {
  font-size: 0.85rem;
}

/* Make pagination text smaller */
.pagination .page-link {
  font-size: 0.75rem;
  padding: 0.2rem 0.4rem;
  line-height: 1.2;
}

/* Compact controls for pagination and selectors */
.compact-controls {
  min-height: 30px;
}

.compact-controls .pagination {
  margin: 0;
}

/* Make select control text smaller */
.form-control {
  font-size: 0.75rem;
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
}

/* Reduce spinner size */
.spinner-border {
  width: 1rem;
  height: 1rem;
}

/* Make table rows clickable */
.cursor-pointer {
  cursor: pointer;
}

.table tbody tr {
  cursor: pointer;
}

.table tbody tr:hover {
  background-color: #f0f7ff !important;
}

/* VehicleMMR component styles */
.vehicle-mmr-container {
  margin-top: 0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}

/* Card header styling */
.card-header h6 {
  color: #495057;
  font-weight: 600;
}

/* Info alert styling */
.alert-info {
  background-color: #f8f9fa;
  border-color: #e9ecef;
  color: #6c757d;
}
</style>
